import React from "react";
import { MachinePolicyPage } from "./MachinePolicyPage";
interface CreateMachinePolicyPageProps {
    spaceId: string;
}
export function CreateMachinePolicyPage({ spaceId }: CreateMachinePolicyPageProps) {
    return <MachinePolicyPage create spaceId={spaceId}/>;
}
